<div class="modal-body">
    <rask-list [data]="avlaggInfo">
        <rask-list-column header="Avlägg etikett" field="avlaggEtikett" [sortable]="true"></rask-list-column>
        <rask-list-column header="Vägtyp" field="vagTyp" [sortable]="true"></rask-list-column>
        <rask-list-column header="Väghållare" field="vaghallare" [sortable]="true"></rask-list-column>
        <rask-list-column header="Väghållar typ" field="vaghallartyp" [sortable]="true"></rask-list-column>
        <rask-list-column header="Högsta tillåtna hastighet" field="hogstaTillatnaHastighet"
            [sortable]="true"></rask-list-column>
        <rask-list-column header="Avstånd(Meter)" field="avstand"
            [sortable]="true"></rask-list-column>
        <rask-list-column header="ÅDT" field="adt" [sortable]="true"></rask-list-column>
        <rask-list-column header="Tillstånds information" field="tillstandInfo" [sortable]="true"></rask-list-column>
        <rask-list-column header="" field="hasArtrikvagmiljo">
            <ng-template let-value>
                @if(value){
                <rask-icon text="Avlägg ligger inom 50 meter från en artrik vägmiljö."
                    icon="fal fa-exclamation-circle error"></rask-icon>
                }
            </ng-template>
        </rask-list-column>
    </rask-list>
</div>
<div class="modal-footer">
    <rask-button color="secondary" (click)="dismiss()">Stäng</rask-button>
</div>